<template>
  <div class="main">
    <Header
      :show="true"
      title="退砼记录"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-cell-group>
        <van-field
          v-model.trim="listQuery.data.singleNo"
          label="任务编号"
          placeholder="请输入"
        />
      </van-cell-group>
      <div style="padding: 16px">
        <van-button
          round
          block
          type="info"
          :loading="table.loading"
          @click="handleQuery"
        >
          查询
        </van-button>
      </div>
      <el-table
        ref="table"
        :loading="table.loading"
        :data="table.data"
        style="width: 100%"
        row-key="serialNum"
        @row-click="onTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              class="table-expand-form"
            >
              <el-form-item label="任务编号">
                <span>{{ row.singleNo }}</span>
              </el-form-item>
              <el-form-item label="毛重/吨">
                <span>{{ row.grossWeight }}</span>
              </el-form-item>
              <el-form-item label="皮重/吨">
                <span>{{ row.tareWeight }}</span>
              </el-form-item>
              <el-form-item label="累计方量/m³">
                <span>{{ row.sumAmount }}</span>
              </el-form-item>
              <el-form-item label="密度 km/m³">
                <span>{{ row.density }}</span>
              </el-form-item>
              <el-form-item label="退砼状态">
                <el-tag
                  v-if="row.auditStatus == 0"
                  type="info"
                >
                  待审核
                </el-tag>
                <el-tag
                  v-if="row.auditStatus == 1"
                  type="warning"
                >
                  审核通过
                </el-tag>
                <el-tag
                  v-if="row.auditStatus == -1"
                  type="danger"
                >
                  审核不通过
                </el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="任务编号"
          props="singleNo"
          align="center"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.singleNo }}
          </template>
        </el-table-column>
        <el-table-column
          label="毛重/吨"
          props="grossWeight"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.grossWeight }}
          </template>
        </el-table-column>
        <el-table-column
          label="退砼状态"
          prop="auditStatus"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.auditStatus == 0"
              type="info"
            >
              待审核
            </el-tag>
            <el-tag
              v-if="row.auditStatus == 1"
              type="warning"
            >
              审核通过
            </el-tag>
            <el-tag
              v-if="row.auditStatus == -1"
              type="danger"
            >
              审核不通过
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleQuery"
      />
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { getList, auditConcrete } from "@/api/return-concrete";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
        data: {
          singleNo: "",
          vehicleNo: "",
          driverName: "",
        },
      },
      table: {
        loading: false,
        key: "table",
        total: 0,
        data: [],
      },
    };
  },
  computed: {},
  created() {
    this.handleQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleQuery() {
      const { limit, page, data } = this.listQuery;
      const payload = { ...data, limit, page };
      this.table.loading = true;
      getList(payload)
        .then(({ data }) => {
          const {
            page: { total, records },
          } = data;

          this.table.data = records;
          this.table.total = total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onDateQueryChoose(val) {
      this.listQuery.data.date = val;
      this.listQuery.showCalendar = false;
    },
    onStatusQueryChoose(val) {
      this.listQuery.data.detectStatus = val.value;
      this.listQuery.showStatusActionSheet = false;
    },
    onTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/owdr/create",
        query: row,
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell__title {
  max-width: 30%;
  font-size: 2vh;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
.content {
  padding-bottom: 80px;
}
.table-expand-form {
  padding: 0 12px;

  .el-form-item {
    margin: 4px 0px;
  }
}
</style>
